import {Component, EventEmitter, Inject, Output} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-list-popup',
    templateUrl: './list-popup.component.html',
    styleUrls: ['./list-popup.component.scss']
})
export class ListPopupComponent {
    @Output() uploadEvent: EventEmitter<any> = new EventEmitter<any>();
    files: File[] = [];

    constructor(private dialog: MatDialogRef<ListPopupComponent>, @Inject(MAT_DIALOG_DATA) data: any) {
        this.files = data.files;
    }

    close(): void {
        this.dialog.close();
    }

    onUploadFiles(files: any): void {
        this.uploadEvent.emit(files);
        this.dialog.close();
    }

    onDeleteFiles(file): any {
        this.files = Array.from(this.files).filter(item => {
            return item !== file;
        });
    }
}
